import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';
import { DefaultRoleType } from '@shared/enums/global.enum';
import { UserType } from '@shared-features/enums';

export class Role extends Model {
  @Expose() id: number;
  @Expose() name: string = '';
  @Expose() phoneKey: string = '';
  @Expose() isDefault: boolean;
  @Expose() isActive: boolean;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() code: number;
  @Expose() defaultRoleType: DefaultRoleType;
  @Expose() userType: UserType;
  @Expose() userRole?: string;

  constructor() {
    super();
  }
}
